import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    logoDisplay: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #E1E1E1',
        borderRadius: '2px',
        height: '380px',
    },

    imageTitle: {
        marginBottom: '10px !important',
    },

    imageBox: ({ width, height }) => ({
        width,
        height,
        border: '1px solid #B2B2B2',
        borderRadius: '4px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }),

    image: {
        width: '100%',
        height: '100%',
        // imageBox is a flex container and this img is its flex item — without
        // these, the item's default min-width/min-height (the image's own
        // intrinsic size) can override width/height above and break objectFit,
        // letting the image stretch instead of cropping to fit the box.
        minWidth: 0,
        minHeight: 0,
        objectFit: 'cover',
        display: 'block',
    },

    imagePlaceholder: {
        width: '64px',
        height: '64px',
        objectFit: 'contain',
        display: 'block',
    },

    imageControls: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '8px',
    },

    iconButton: {
        width: '36px',
        height: '36px',
    },
}));
